// extracted by mini-css-extract-plugin
export default {"content":"Fvm5s7tb","desktop":"desktop","commentsButton":"CU_w6VSv","mobile":"mobile","list":"CltrZaO2","item":"zphvNM1O"};